import React from 'react';
import PageHeader from './Component/PageHeader';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Divider, TableHead } from '@mui/material';
import CollierVanderpool1957 from './Images/CollierVanderpool1957.png';
import plutonicunits from './Images/plutonicunits.jpg';
import Regionalgeologicstructures from './Images/Regionalgeologicstructures.png'
import Maps from './Component/Maps';


const MRDS2011 = [
    { Township: "6N 8E Sec. 08 SBM", latitude: "34.62696000040", longitude: "-116.16946000000 (Stedman, Buckeye)" },
    { Township: "6N 8E Sec. 05 SBM", latitude: "34.63334999980", longitude: "-116.16752000000 (Bagdad-Chase)" },
    { Township: "6N 8E Sec. 08 SBM", latitude: "34.62694000000", longitude: "-116.16750000000 (Bagdad-Chase)" },
    { Township: "6N 8E Sec. 08 SBM", latitude: "34.62751999970", longitude: "116.16775000000 (Bagdad-Chase" },

];

const OWNERSHIP = [
    { Year: "1990", Owner: "Owned by Bagdad Chase Mining Company California" },
    { Year: "1978", Owner: "Bagdad-Chase Inc. California" },
    { Year: "1978", Owner: "Clark Mining and Exploration, California" },
    { Year: "1943-1977", Owner: "John Hobbs" },
    { Year: "1940-1943", Owner: "Bagdad-Chase Ltd., California" },
    { Year: "1938-1939", Owner: "Operated by D'Aix Syndicate, California" },
    { Year: "1910-1916", Owner: "Operated by Pacific Mines Corporation., California" },
    { Year: "1904-1919", Owner: "Owned by the Bagdad-Chase Mining Company, California" },
];

const BagdadChaseDeposit = () => {
    return (
        <div className='mx-16 py-8'>
            <PageHeader pageTitle="Mineral Deposit Characteristics" />

            <div className='text-xl'>Bagdad-Chase Mine, Northern Bullion Mountains, San Bernardino County, California</div>
            <div className='pt-5'>Gregg Wilkerson, 2020</div>
            <div><a href='mailto:yosoygeologo@gmail.com'>yosoygeologo@gmail.com</a></div>
            <div className='pt-10 pb-5 text-xl text-center font-bold'>Acknowledgement and Disclaimer</div>
            <div className='pb-5'>
                The information in this paper is taken largely from published and public sources. I have
                reproduced this material and present it pretty much as we found it, not trying to harmonize
                discrepancies in mine or geologic descriptions. I have changed verb tenses for readability
                and have used some paraphrase. I have expanded abbreviations or special characters
                with full text (e.g. feet instead of ft., inches instead of “) Italics indicate quotations. Authors
                of the original information are indicated at the end of each paragraph. Paragraphs without
                a citation are our own materials. The maps in this report have been compiled and rectified
                from digital and paper copies of original sources that were made at different scales and
                in different geographic projections. Therefore, many of the maps had to be adjusted or
                stretched. They do not fit perfectly. Most are accurate to within 100 feet, but reproduction
                and projection errors can be as much as 300 feet for some maps. PLSS means Public
                Land Survey System. That survey data was obtained from the U.S. Bureau of Land
                Management website.
            </div>

            <div className='pb-5'>
                MRDS, 2011, Mineral Resources Data System, U.S. Geological Survey,
                <a href='https://mrdata.usgs.gov/mrds/' target='_blank' rel='noreferrer noopener'>https://mrdata.usgs.gov/mrds/</a>. This database relies on records that, in many cases, are
                inaccurate or imprecise. For example, if a report describes a mine as being in “Section
                9”, with no other information, MRDS plots the mine location in the center of the section. If
                a mine is reported in “SW <sup>¼</sup>” of a section, MRDS plots the mine in the center of that SW
                quarter-section. Where I could confidently adjust an MRDS location of a mineral deposit
                to features identifiable in aerial photographs or topographic maps, I did so.
            </div>

            <div className='pb-10'>
                Help me make this report better. If you have any photographs, memories or reports for
                this mine that you can share, please send them to <a href='mailto:yosoygeologo@gmail.com'>yosoygeologo@gmail.com</a> so we can
                incorporate into this paper.
            </div>

            <div className='pb-5 text-xl font-bold'>LOCATION: (MRDS, 2011)</div>

            <div className='pb-5'>
                <TableContainer component={Paper} className='w-full max-w-full overflow-x-auto' sx={{ backgroundColor: '#102E4A' }}>
                    <Table aria-label="transparent table" >

                        <TableBody>
                            {MRDS2011.map((row) => (
                                <TableRow
                                    key={row.Township}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell style={{ color: '#C9E1E3' }}><div className="">{row.Township}</div></TableCell>
                                    <TableCell style={{ color: '#C9E1E3' }}><div className="">{row.latitude}</div></TableCell>
                                    <TableCell style={{ color: '#C9E1E3' }}><div className="">{row.longitude}</div></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div className='pb-5 text-xl font-bold'>Alternative Names</div>
            <div className='pb-5'>
                The mines of the Bagdad-Chase-Stedman-Ragtown area were known as the “Buckeye”
                Mining District. Tucker and Sampson (1940b) called it the “Stedman” District. Other
                mine names for the group of mines that became the Bagdad-Chase consolidated are
                Pacific Mine; Camp Rochester; Barstow Mill; Pacific Mines; Roosevelt Consolidated,
                and Butte Hill Group. This Bagdad-Stedman mine area for this report encompasses 183
                acres. See Figure 13.

            </div>
            <div className='pb-5'>
                The mine and mill of this former Au-Cu-Ag-Pb-Zn occurrence is located in secs. 7 & 8,
                T6N, R8E, SBM, 0.3 km (0.2 mile) SSE of Stedman (7 miles S of Ludlow), on private
                (patented) land. Discovered in 1880. Property is comprised of 20 patented claims. Owned
                by Bagdad Chase, Inc. (2007). MRDS database stated accuracy for this location is 100
                meters. Longitude and latitude represent the open pit mine symbol immediately above
                the name "Bagdad Chase Mine" on the Ludlow 7.5 minute quadrangle. Six mine shaft
                symbols are located within 0.1-mile NE to W of the open pit mine symbol. The mine is 47
                miles by Interstate 40 east from Barstow to Ludlow, CA, then 7.6 miles south from Ludlow
                on Bagdad Chase Road. The historic townsite of Stedman is located 0.2 miles north of
                the mine on Bagdad Chase Road (https://www.mindat.org/loc-88031.html accessed May
                19, 2020).
            </div>
            <div className='pb-5'>
                That the principal source of copper in San Bernardino County has been the Bagdad
                Chase gold mine is a fact not generally known. The Bagdad Chase ore has averaged
                between 1 and 2 percent copper (Wright, 1953, p. 60).
            </div>
            <div className='pb-5'>
                The MRDS data and field inspection of May 24, 2020 show two mill sites at the BagdadChase . One is northeast the Stedman townsite in SE1/4, Section 5, T.6N, R,8E, SBM.
                The other is in NW1/4 Section 8, T.6N, R,8E, SBM.
            </div>
            <div className='pb-2 text-xl font-bold'>OWNERSHIP</div>
            <div className='pb-5'>(https://www.mindat.org/loc-88031.html accessed May 19, 2020).</div>

            <div className='pb-5'>
                <TableContainer component={Paper} className='w-full max-w-full overflow-x-auto' sx={{ backgroundColor: '#102E4A' }}>
                    <Table aria-label="transparent table" >

                        <TableBody>
                            {OWNERSHIP.map((row) => (
                                <TableRow
                                    key={row.Year}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell style={{ color: '#C9E1E3' }}><div className="">{row.Year}: </div></TableCell>
                                    <TableCell style={{ color: '#C9E1E3' }}><div className="">{row.Owner}</div></TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <div className='pb-2 text-xl font-bold'>HISTORY</div>
            <div className='pb-5 text-xl text-center'>1880-1901</div>
            <div className='pb-5'>
                Copper and gold mineralization in the area of the current Bagdad-Chase and Roosevelt
                mines was discovered most likely around the early to late 1880's by John Suter,
                roadmaster for the Atlantic and Pacific subsidiary of the Santa Fe Railway. Discovery
                dates, which have been reported or which can be inferred from various sources, range
                from 1880 to 1903: 1880 (Mansfield, 2005); early 1890s (Ross, 2006); 1896 (Tucker,
                1934b); 1898 (Feller, 2002); 1899 (USGS, MRDS); 1899 (Belden, 1952); 1903 (Tucker,
                1917, 1934a). (https://www.mindat.org/loc-88031.html accessed May 19, 2020).
            </div>
            <div className='pb-5'>
                As a point of historical interest, the town of Stedman ( or Steadman) was once named
                Rochester. The mines in that district, including the Bagdad Chase, were served by a
                railroad, known as the Ludlow and Southern, which ran 7½ miles from Ludlow to
                Rochester. It was constructed between 1899 and 1901 and operated until the mid1920's (Davis W.Buford, private report, 1940; Wright, 1953, p. 71).
            </div>

            <div className='pb-5 text-xl text-center'>1901-1910</div>
            <div className='pb-5'>
                Suter was in the Bullion Mountains looking for a source of water for the railroad. The first
                mining district in the area was called the Buckeye Mining District. Suter sold his mines
                and claims in the early 1890s to stockholders of the New York Central Railroad, who
                organized the Bagdad Mining and Milling Company. 1901 -- 1910: the Bagdad Mining
                and Milling Company sent their first shipment of ore to the Randsburg-Santa Fe
                Reduction Company's stamp mill in Barstow in late 1901. The mill was equipped with fifty
                (50) 1,000-pound stamps and five regrinders, and had a cyanide plant with a capacity of
                200 short tons of ore per day. The mill was owned by the same investors who purchased
                the Bagdad. The mill was originally built to handle ore from Randsburg. In addition to
                Suter's original Bagdad and Roosevelt mines, John R. Gentry had developed another
                productive mine that was purchased by the Benjamin E. Chase Gold Mining Company.
                Chase, who was president of the Central Bank of Rochester, New York, was also one of
                the investors in the Bagdad, and the companies merged to form the Bagdad Chase Gold
                Mining Company. For a time, the Buckeye District was called the Rochester District in
                honor of the home of several of the investors. Chase was also president of the Ludlow
                and Southern Railway, which had been completed in 1903 to transport ore from the mine
                to the Santa Fe Railway at Ludlow. The combined mines were known as the Bagdad
                Chase. By 1905, the district was beginning to be called the Stedman District after the
                nearby mining town of Camp Rochester was renamed Stedman in honor of J. H.
                Stedman, Executive Secretary of the group of investors. From 1904, when mining began
                in earnest, to 1910, production from the Bagdad-Chase Mine reportedly amounted to
                150,000 tons of ore with a total value of $4.5 million in gold produced, making the district
                the largest single source of gold in San Bernardino County. It was also the largest single
                source of copper in the County and yielded a significant amount of silver, as well. Between
                1904 and 1910, the 150,000 tons of ore were hauled from the mine to Barstow where the
                ore was treated in a cyanide plant. Due to the presence of copper carbonates and silicates
                in the ore, gold recovery reportedly was about 55%. The ore also had an average reported
                value of $20.00 in gold per ton, and tailings' loss amounted to $5.00 in gold per ton
                (Tucker and Sampson, 1940; Tucker, 1934a) (https://www.mindat.org/loc-88031.html
                accessed May 19, 2020).
            </div>
            <div className='pb-5'>
                With a gold price of $20.67 per troy ounce during the period 1904-1910, the reported $4.5
                million in gold production amounts to ~217,700 troy ounces gold recovered. At 55%
                recovery, total gold content of the 150,000 tons of ore would be ~395,800 troy ounces
                and an ore grade of 2.639 troy ounces gold per ton. A tailings loss of $5.00 per ton in gold
                amounts to a loss of 0.242 troy ounces gold per ton for a total of 36,300 troy ounces gold
                lost to the tailings. [Approximately 130,000 tons of these tailings were available for
                reprocessing which began in 1932, and head samples reportedly assayed 0.155 troy
                ounces gold per ton (20,150 troy oz total gold; 18,740 troy ounces recoverable gold at
                93% recovery; Tucker, 1934b)]. If the reported average value of $20.00 per ton of ore
                refers to gold recovered from the 150,000 tons of ore, the total amount and value of gold
                produced would be ~145,000 troy ounces (0.968 troy ounces gold per ton recovered) and
                $3 million, respectively. Using a total gold value of $25.00/ton ($20.00 recoverable plus
                $5.00 tailings loss), the average ore grade equates to 1.21 troy ounces gold per ton, which
                amounts to 181,500 troy ounces gold in 150,000 tons ore. Although the reported $20.00
                per ton gold value of the ore and the $5.00 per ton loss in gold value to tailings are not
                consistent with the reported 55% recovery, the amount of gold produced (~145,000 troy
                ounces), the total gold content of the ore (181,500 troy ounces) and the corresponding
                grades (0.968 troy ounces gold per ton recovered, 1.21 troy ounces gold per ton of ore)
                are probably reasonable for the period 1904-1910. From the apparent inconsistencies in
                the reported figures given above for the period 1904-1910, either the dollar value ($4.5
                million) of gold produced during 1904-1910 is overstated, or the amount of ore processed
                (150,000 tons) and/or the average per-ton value of the ore are understated. Although ore
                grades during the early period of mining (1904-1910) can be expected to be higher due
                to high-grading than during later years (1910-1916), using the $4.5 million value of gold
                recovered to estimate average ore grade for 1904-1910 gives a significantly higher
                average ore grade (2.639 troy ounces gold per ton) than reported from various other
                sources for the period 1910-1916: average ore grades of 0.159 to 0.486 troy ounces gold
                per ton for various blocks of ore mined from 1910-1916 (Tucker, 1934a); average of 0.35
                troy ounces gold per ton mined from 1910-1916 (Tucker and Sampson, 1940, p 232). An
                upper limit on the estimate of gold recovered during 1904-1910 is ~217,700 troy ounces
                based on the reported $4.5 million value of gold produced and gold price of $20.67. The
                upper limit of total gold content for the 150,000 tons of ore processed in Barstow is
                ~395,800 troy ounces gold (average grade of 2.639 troy ounces Au/ton) based on the
                reported $4.5 million value of gold produced and reported 55% recovery. This MRDS
                reporter estimates that gold production and value of gold produced during 1904-1910 are
                probably on the order of ~145,000 troy ounces and $3 million, respectively. Total gold
                content in the 150,000 tons of ore is estimated to be ~181,500 troy ounces with average
                grade of ~1.21 troy ounces gold per ton (https://www.mindat.org/loc-88031.html accessed
                May 19, 2020).
            </div>

            <div className='pb-5 text-xl text-center'>1910-1916</div>
            <div className='pb-5'>
                1910 to 1916: By early 1910 production and profits were down. The Bagdad Chase Gold
                Mining Company put its Stedman District operations up for sale, and the operations were
                purchased by the Pacific Mines Corporation in late 1910. Under the direction of mining
                engineer, John Hays Hammond, production was increased to 100 short tons of ore per
                day and the labor force increased to 75 men. The entire operation was modernized, and
                the ore was sent to Clarksdale (near Jerome), Arizona for processing. During this period,
                the mine reportedly produced $1.5 million in gold, silver, and copper. Production is
                reported at 120,000 tons ore. The average grade of ore mined and shipped was 0.35 troy
                oz Au/ton (42,000 troy oz Au), 1.5 troy oz silver/ton (180,000 oz Ag), 1.82% copper (2184
                tons) (Tucker and Sampson, 1940, p. 232). By the end of 1915, the Bagdad Chase had
                four vertical shafts from 120 to 400 feet deep, one decline 450 feet long, and several
                thousand feet of levels, drifts, and crosscuts. The ore body measured 2000 feet long and
                8 to 20 feet wide at the surface. By 1916, equipment had become worn and obsolete, and
                production and profits were again down; operations ceased, and the mine went into
                receivership (https://www.mindat.org/loc-88031.html accessed May 19, 2020).
            </div>

            <div className='pb-5 text-xl text-center'>1930-1954</div>
            <div className='pb-5'>
                Starting in the early 1930s, Bagdad Chase was leased to several different parties who
                operated from time to time. 1932: In 1932, the Barstow Metals Extraction Co. began
                construction of a plant in Barstow to process Bagdad-Chase Mine tailings that were sent
                to the mill during the early 1900s (1904-1910). During this earlier period, 150,000 tons of
                ore were shipped to Barstow for processing, and the estimated tonnage of tailings
                available for treatment in 1932 was 130,000 tons. Head samples of tailings assayed:
                0.155 troy oz gold/ton (20,150 troy oz Au total; 18,740 troy oz Au recoverable), 0.93 troy
                oz silver/ton (120,900 troy oz Ag total), and 0.70% copper (910 tons Cu total), with
                estimated recoveries of 93% of gold, 70% of silver, and 96% of copper. The estimated
                total value of gold, silver, and copper recovery was $4.69 per ton ($609,700 total; estimate
                $507,000 in Au) at a cost of $1.97 per ton (Tucker, 1934b). 1938 - 1939: the D'Aix
                Syndicate operated from 1938 to 1939 and reportedly shipped 850 short tons of ore to
                Magma Copper Company's smelter at Superior, Arizona; some shipments also went to
                American Smelting and Refining Company's smelter at Hayden, Arizona. The ore
                reportedly averaged $9.80/short ton in Au (0.28 troy oz Au/short ton; 238 oz Au total),
                $2.85/short ton in Ag, and 0.89% Cu (7.6 tons Cu Total). Total production in gold, silver,
                and copper up to 1940 was $6,013,000 (Tucker and Sampson, 1940, p. 232). 1939 -
                1954: the Bagdad Chase was operated by Frank W. Royer from 1939 to 1943, and by
                Don L. Love beginning in 1943. Between 1943 and 1947 the lessee operated from the
                125-foot shaft, stoping ore between the 90-foot level and the glory hole. Approximately
                60,000 tons of ore were mined from this area. During 1947 and 1948 ore was mined from
                the 200-foot level in another vertical shaft. Early in 1949, the lessee worked in and around
                the old stopes on the 400-foot level of the inclined shaft (decline). The lessee reported
                mined 5000 tons ore in 1949, 2775 tons in 1950, and an average of one car (100-tons)
                per week during 1951 (Stewart, 1951). The Bagdad Chase was one of only four gold
                mines in California to be authorized to remain in production during World War II; the ore's
                silica content made it useful as a flux in smelting. Although not very profitable, the mine
                operated continuously from 1940 to 1954 (https://www.mindat.org/loc-88031.html
                accessed May 19, 2020).
            </div>
            <div className='pb-2 text-xl font-bold text-center'>MINING AND PROCESSING HISTORY</div>
            <div className='pb-5 text-xl text-center'>1910 to 1987</div>
            <div className='pb-5'>
                Mining and processing methods: Early high-grading of mineralized outcrops was followed
                by shaft-sinking [vertical and inclined (decline)], and underground drifting, stoping, and
                room and pillar mining. From 1901-1910, ore was processed by stamp mill, other crushing
                methods, and by cyanide plant in Barstow, California. From 1910-1916, ore was sent to
                a smelter in Clarksdale (near Jerome), Arizona for processing. In 1932 the Barstow
                Metals Extraction Co. began construction of a plant in Barstow to process Bagdad-Chase
                Mine tailings that were sent to the mill during the early 1900s. The tailings processing
                circuit included: tube mill grinder using Oceanside (San Diego Co.) pebbles; water
                washing; agitation using Dorr agitator and Pachucas (air agitation tanks); acid treatment
                (H2SO4 and HCl); neutralization with lime; addition of iron scrap and zinc shavings; Dorr
                thickeners; cyanide treatment; and filtering (Merrill filters). From 1938-1939, ore was
                shipped from the Bagdad Chase Mine to Magma Copper Company's smelter at Superior,
                Arizona; some shipments also went to American Smelting and Refining Company's
                smelter at Hayden, Arizona. Around 1972 Bagdad Chase, Inc. reportedly began open-pit
                operations at Stedman, which continued through 1975. In 1987, Bentley Resources,
                Vancouver, B. C., announced plans for extensive exploration and drilling around the
                Bagdad Chase, to bring the Bagdad Chase operations back into production, and to pour
                the first gold dore bar in the second quarter of 1988. Operation plans called for an annual
                production of 20,000 troy oz Au from three open pits: Bagdad, Middle Mine, and
                Roosevelt. Capital cost was estimated at $4.5 million; production costs were estimated at
                $152(U.S.). Test metallurgical work by Hazen Research Inc. showed ~95% gold recovery
                using an agitated vat cyanide leach. The ore was to be ground to 75% minus-200 mesh;
                final gold recovery was to be by the Merrill-Crowe system to produce gold dore bars. This
                MRDS reporter found no record of implementation of these plans
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noopener noreferrer'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='pb-2 text-xl font-bold text-center'>RECLAMATION</div>
            <div className='pb-5'>
                The nature and amount of reclamation in the Bagdad-Chase Mine area can be
                determined by contacting the California Department of Conservation's Office of Mine
                Reclamation, Sacramento, CA, or the San Bernardino County, CA, Land Use Services
                Department (phone: 909-387-8311), which oversees mine reclamation; San Bernardino
                County is Lead Agency for mine reclamation. Satellite imagery and high-altitude aerial
                photographs from Google Earth and NASA World Wind 1.3 suggest that the mine is idle
                and has not been fully reclaimed; little if any equipment remains onsite. Open-pit workings
                (1972-1975; possibly late 1980s): three relatively shallow pits (Bagdad, Middle Mine, and
                Roosevelt pits) and adjacent hillside excavations involving approximately 0.02 square
                mile of disturbed ground (estimated from satellite imagery and aerial photos from Google
                Earth and NASA World Wind 1.3) (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noopener noreferrer'>https://www.mindat.org/loc-88031.html</a> accessed May
                19, 2020).
            </div>

            <div className='pb-2 text-xl font-bold text-center'>CURRENTSTATUS</div>
            <div className='pb-5'>
                The mine appears to have been idle since about 1976 when the first open-pit mining
                operations reportedly ceased; some additional open-pit mining may have taken place
                during the late 1980's, but no record of late 1980's mining
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noopener noreferrer'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>
            <div className='pb-2 text-xl font-bold'>GEOLOGY</div>
            <div className='text-xl font-bold text-center'>GEOLOGIC MAPPING</div>
            <div className='text-center pb-5'>1:250,000</div>
            <div className='pb-5'>Bortugno and Spittler (1986) mapped the area of the Bagdad-Chase mine as Miocene
                volcanics:</div>

            <div>
                <TableContainer
                    component={Paper}
                    sx={{
                        backgroundColor: 'transparent',
                        display: 'flex', // Flex helps center with auto margin
                        justifyContent: 'center',
                        maxWidth: 'fit-content', // Only as wide as content
                        margin: 'auto' // Centers the container horizontally
                    }}
                >
                    <Table size="small" aria-label="a dense table transparent" sx={{ tableLayout: 'auto' }}>
                        <TableBody>
                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#fdc3b1] py-2 px-5 border-[#000000] border-2 text-center'>
                                        MPv
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold text-xl'>Miocene-Pilocene volcanic rocks</div>
                                    <div>(b-basalt; t-rhyolite tuff)</div>
                                </TableCell>
                            </TableRow>

                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#ffba83] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Mi
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold text-xl'>Miocene shallow intrusive rocks</div>
                                    <div>(a-andesitic; d-dacitic and rhyolitic; b-basaltic)</div>
                                </TableCell>
                            </TableRow>

                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#ffba83] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Mgv
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold text-xl'>Glendora Volcanics</div>
                                    <div>(a-andesite; b-basalt; r-rhyolite)</div>
                                </TableCell>
                            </TableRow>


                            <TableRow>
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#fdc3b1] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Mv
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold text-xl'>Miocene volcanic rocks</div>
                                    <div>(a-andesite; b-basalt; d-dacitic; p-pyroclastic rocks)</div>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>

            <div className='text-center pb-5 pt-10'>1:100,000</div>
            <div className='text-center pb-5'>Phelps and others (2012) mapped the area of the Bagdad-Chase mine as Quaternary
                and Tertiary volcanic rocks:</div>


            <div>
                <TableContainer
                    component={Paper}
                    sx={{
                        backgroundColor: 'transparent',
                        display: 'flex', // Flex helps center with auto margin
                        justifyContent: 'center',
                        maxWidth: 'fit-content', // Only as wide as content
                        margin: 'auto' // Centers the container horizontally
                    }}

                >

                    <Table sx={{ tableLayout: 'auto' }} size="small" aria-label="a dense table transparent">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={2}>
                                    <div className='p-5 text-xl font-bold'>QUATERNARY AND LATE TERTIARY VOLCANIC ROCKS</div>
                                </TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Qv
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Volcanic rocks (Quaternary)</div>

                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell style={{ width: '10%' }}>

                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Volcanic rocks of Pisgah crater (latest Pleistocene)</div>

                                </TableCell>
                            </TableRow>

                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Qvp1
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>First eruptive phase</div>

                                </TableCell>
                            </TableRow>

                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Qvp2
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Second eruptive phase</div>

                                </TableCell>
                            </TableRow>

                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Qvp3
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Final eruptive phase</div>

                                </TableCell>
                            </TableRow>

                            <TableRow >
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Qvp4
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Cinders</div>

                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell style={{ width: '10%' }}>

                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Sunshine crater (Pleistocene)</div>

                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Qvss
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Sunshine cone flows</div>

                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        Qvsl
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Lavic flows</div>

                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell style={{ width: '10%' }}>
                                    <div className='bg-[#e7a880] py-2 px-5 border-[#000000] border-2 text-center'>
                                        QTv
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className='font-bold'>Lava flows (early Pleistocene to late Pliocene)</div>

                                </TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </TableContainer>

            </div>

            <div className='text-center py-5'>1:62,500</div>
            <div className='pb-5'>
                Dibblee (1967a) and Dibblee and Minch (redrafting 2008f) mapped the area of the
                Bagdad-Chase mine as Tertiary volcanic intrusives and flows.
            </div>


            <div className='mb-5'>
                <div className='flex justify-center items-center'>
                    <div className='w-[100px] bg-[#CE7767] text-center font-bold p-4 border-2 border-[#42180F]'>Tbi</div>
                    <div className='w-[100px] bg-[#CE7767] text-center font-bold p-4 border-2 border-[#42180F]'>Tap</div>
                    <div className='w-[100px] bg-[#D38979] text-center font-bold p-4 border-2 border-[#42180F]'>Tah</div>
                </div>

                <div className='text-xl font-bold text-center pt-5'>INTRUSIVE VOLCANIC ROCKS</div>
                <div>
                    Volcanic intrusives, as plugs, pods, or dikes, intrusive into pre-Tertiary and Tertiary volcanic and sedimentary rocks; probably fill vents and fissures through which volcanic rocks of this Tertiary assemblage erupted; age, Tertiary, probably Oligocene or Miocene<br />
                    <span className='font-bold'>Tbi</span> Intrusive basalt, similar to basalt of the volcanic and sedimentary rocks described below, but diabasic, non-vesicular; occurs as dikes, probably feeder dikes to basalt flows<br />
                    <span className='font-bold'>Tap</span> Andesite porphyry, ranges to dacite porphyry and quartz latite porphyry, greenish, pinkish, to brownish-gray, massive to rarely faintly flow-laminated with mostly plagioclase phenocrysts in subvitreous to microcrystalline groundmass; forms irregular intrusive masses or volcanic piles<br />
                    <span className='font-bold'>Tah</span> Andesite porphyry, similar to <span className='font-bold'>Tap</span> but hydrothermally leached to light buff, softer somewhat porous rock with feldspars partly altered to cream-white kaolinite, and iron content largely leached; forms central part of large mass of andesite porphyry
                </div>
            </div>


            <div className=''>
                <div className='lg:flex justify-center items-center'>
                    <div className='lg:w-[100px] bg-[#BFA460] text-center font-bold p-4 border-2 border-[#271D0B]'>Tfa</div>
                    <div className='lg:w-[100px] bg-[#C0A561] text-center font-bold p-4 border-2 border-[#271D0B]'>Tfb</div>
                    <div className='lg:w-[100px] bg-[#CE7767] text-center font-bold p-4 border-2 border-[#271D0B]'>Tb</div>
                    <div className='lg:w-[100px] bg-[#CE7767] text-center font-bold p-4 border-2 border-[#271D0B]'>Ta</div>
                    <div className='lg:w-[100px] bg-[#CE7767] text-center font-bold p-4 border-2 border-[#271D0B]'>Tap</div>
                    <div className='lg:w-[100px] bg-[#BFA460] text-center font-bold p-4 border-2 border-[#271D0B]'>Ttc</div>
                    <div className='lg:w-[100px] bg-[#BFA460] text-center font-bold p-4 border-2 border-[#271D0B]'>Tt</div>
                    <div className='lg:w-[100px] bg-[#E8C4BA] text-center font-bold p-4 border-2 border-[#271D0B]'>Tr</div>

                </div>

                <div className='text-xl font-bold text-center pt-5'>VOLCANIC AND SEDIMENTARY ROCKS</div>
                <div className='pb-5'>
                    Assemblage of volcanic flows, pyroclastic rocks, and coarse sedimentary rocks characterized by extreme lenticularity and intergradation of lithologic units; thickness about 14,000 feet; unconformably on Mesozoic granitic rocks and earlier Tertiary volcanic intrusive rocks; unfossiliferous; age, Tertiary, most probably Oligocene or early Miocene, on basis of lithologic similarity to volcanic and sedimentary rocks of Oligocene or early Miocene age in Cady Mountains northwest of quadrangle (Dibblee and Bassett, 1966)<br />
                    <span className='font-bold'>Tfa</span> Fanglomerate, grayish-brown to red, crudely bedded, weakly to moderately consolidated, of poorly sorted subrounded fragments as large as 2 feet in diameter mostly of Tertiary andesite and andesite porphyry, in matrix of coarse andesitic sandstone<br />
                    <span className='font-bold'>Tfb</span> Fanglomerate, dark gray, crudely bedded, weakly to moderately consolidated, of poorly sorted subrounded fragments as large as 2 feet in diameter mostly of Tertiary basaltic detritus in matrix of coarse basaltic sandstone<br />
                    <span className='font-bold'>Tb</span> Basalt, black, massive, moderately hard, finely crystalline, somewhat porous, with minute vugs, in places somewhat brecciated and with subplaty fracture generally parallel to top or base of flows<br />
                    <span className='font-bold'>Ta</span> Andesite, dark-reddish- to greenish-brown, aphanitic to porphyritic, massive, hard; forms thick lenticular flows but may be in part intrusive; in places somewhat brecciated, gradational into <span className='font-bold'>Tab</span><br />
                    <span className='font-bold'>Tab</span> Andesite breccia, same as <span className='font-bold'>Ta</span> but much brecciated, unstratified; forms thick flow-breccias, gradational into <span className='font-bold'>Tfa</span> and <span className='font-bold'>Tt</span><br />
                    <span className='font-bold'>Ttc</span> Tuffaceous conglomerate, light gray to tan, bedded, moderately consolidated, composed of poorly sorted small boulders, cobbles, and pebbles of andesite and andesite porphyry embedded in matrix of tuffaceous to andesitic sandstone; gradational into <span className='font-bold'>Tt</span><br />
                    <span className='font-bold'>Tt</span> Tuff breccia, tan to cream-white, moderately consolidated, massive to bedded, composed of scattered to numerous angular fragments of aphanitic to porphyritic andesite embedded in matrix of white to tan tuff, commonly with biotite flakes and in places with small subrounded fragments of devitrified pumice<br />
                    <span className='font-bold'>Tr</span> Rhyolitic felsite, fight-gray to tan, massive to flow-laminated, in places with subplaty fracture, vitreous to microcrystalline; forms short, thick flows or possibly sills
                </div>
            </div>

            <div className='text-center py-5'>1:24,000</div>
            <div className='pb-5'>
                Collier and Vanderpool (1957) mapped the area of the Bagdad Chase mine as Miocene
                to Pleistocene flows, tuffs and pyroclastic rocks. These are cut by antithetic faults
                trending NW to SW and NNE to SSW.
            </div>
            <div className='my-5'><img src={CollierVanderpool1957} alt='' title='' className='mix-blend-multiply mx-auto' /></div>

            <div>They also noted plutonic units in the area:</div>

            <div className='my-5'><img src={plutonicunits} alt='' title='' className='mix-blend-multiply mx-auto' /></div>

            <div className='text-xl font-bold text-center pt-5'>STRATIGRAPHY</div>

            <div>
                The rocks of the Bagdad-Chase-Ragtown mining area consist of -Miocene(?) volcanic
                flows and pyroclastic deposits and a wide variety of Tertiary intrusive rocks (Collier and
                others, 1957, p. 5).
            </div>

            <div className='text-center py-5'>Miocene(?) Volcanic Rocks</div>
            <div className='pb-5'>Pyroclastic Deposits</div>
            <div className='pb-5'>
                Distribution. The volcanic flows and pyroclastic deposits occur essentially in the
                northwestern part of the district. There are several small outcroppings located outside
                the main deposits (Collier and others, 1957, p. 5).
            </div>

            <div className='pb-5'>
                Lithology. The lower part of this formation appears to be a thick sequence of poorly
                bedded rhyolitic tuffaceous deposits containing only minor sedimentary clasts. Locally
                within this unit, there are andesitic or rhyolitic flows (agglomeritic in part). The upper part
                of this formation appears to consist of well to poorly bedded tuffaceous sediments with
                intercalated rhyolite flows. Locally the rhyolite may be pitchstone variety.
                (Collier and others, 1957, p. 5-6).
            </div>

            <div className='pb-5'>
                Relation to other rocks: This formation seems to represent the earliest Tertiary volcanic
                activity and, therefore, would overlie the pre-Tertiary basement rock complex. There
                appears to be an erosional and, in part, an angular unconformity between this sequence
                and the later sequence of volcanic and sedimentary deposits (Collier and others, 1957,
                p. 6).
            </div>

            <div className='text-center py-5'>Tertiary Intrusive Rocks</div>

            <div className='pb-5'>Andesitic Plugs and Stocks</div>

            <div className='pb-5'>
                Located in the district are several Tertiary plugs and a stock. The stock may have
                furnished the mineralizing solutions of the district and, therefore, it is of major
                importance (Collier and others, 1957, p. 6).

            </div>

            <div className='pb-5'>
                Distribution. Small andesite plugs are located in the northwestern part of the district.
                The stock is in the southeastern part of the district (Collier and others, 1957, p. 6).
            </div>

            <div className='pb-5'>
                Lithology. The plugs appear to be mainly andesite. They show no hydrothermal
                alteration, although the surrounding areas are intensely altered. The plugs are
                considered to be later than the mineralization of the district. The andesite porphyry (field
                classification) stock grades throughout its mass in both texture and composition.
                Locally, it may be considered quartz monzonite porphyry. There are also definite
                contacts between what appears to be different rock types and, therefore, the stocks may not be on simply intrusions, but a composite of numerous intrusions (Collier and
                others, 1957, p. 6)..
            </div>
            <div className='my-2'><Divider /></div>
            <div className='text-sm pb-5'>
                <sup>1</sup>  Pitchstone, a volcanic glass with a conchoidal fracture (like glass), a resinous lustre, and a variable composition.
                Its colour may be mottled, streaked, or uniform brown, red, green, gray, or black. It is formed by the rapid cooling
                of viscous lava or magma.
            </div>

            <div className='pb-5'>
                Hydrothermal Activity: The pyroclastic and flow deposits have been intensely altered by
                hydrothermal activity. There has been the development of kaolinite, epidote,sericite,
                pyrite, and possibly some silicification. The entire volcanic sequence has taken on a
                massive appearance and a brownish white color (Collier and others, 1957, p. 6).
            </div>

            <div className='text-xl font-bold text-center'>STRUCTURE AND TECTONIC SETTING</div>

            <div className='pb-5'>
                Regional geologic structures include the Mojave Extensional Belt; Trans Mojave-Sierran
                shear zone and the Eastern California shear zone
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>


            <div className='my-5'><img src={Regionalgeologicstructures} alt='' title='' className='mx-auto' /></div>

            <div className='pb-5'>
                The Bagdad-Chase Mine is located in the northern part of the Bullion Terrane in the
                central Mojave Desert, southern Basin and Range Province. Bagdad-Chase
                mineralization occurs mainly within a quartz-hematite, gold-silver-copper-bearing,
                hydrothermal breccia sill in association with Miocene-age hypabyssal rhyodacite porphyry
                intrusive rocks. In contrast to Miocene extension and concurrent calc-alkaline volcanism
                that was taking place in east-central Nevada in a back-arc setting east of the subducting
                Farallon Plate north of the Mendocino Triple Junction, contemporaneous Miocene
                extension and associated calc-alkaline volcanism in southeastern California (which
                includes the central Mojave) developed opposite and east of the transform that was active
                along the North American plate margin south of the Mendocino Triple Junction. The
                central Mojave underwent extensional deformation, preceded by and contemporaneous
                with basalt to rhyolite volcanism in Miocene time (Gans and others, 2005; Dokka, 1986;
                Walker and others, 1990; Dokka and others, 1998; Glazner and others, 2002). During late
                Cenozoic time, the central Mojave experienced three structurally different and temporally
                separated intervals of deformation (Dokka and others, 1998): 1. ~N-S directed opening
                of the ~24-21 Ma Mojave Extensional Belt (Dokka 1989; Ross, 1995). The northern
                Mojave Desert underwent extension beginning ~24 Ma; detachment faults accounted for
                much of the extension and locally exhumed mid-crustal rocks (metamorphic core
                complexes). 2. ~E-W striking, dextral shearing (~21-18 Ma) along the Trans MojaveSierran shear zone (Dokka and Ross, 1995, 1996, 1998). At ~20 Ma, the kinematics along
                the northern boundary changed from extension to dextral shear and minor extension in
                the Trans Mojave-Sierran shear zone, and rocks within this east-west trending zone
                (southern Sierra Nevada and the central Mojave Desert) were rotated about vertical axes
                as much as ~40-60 degrees clockwise. 3. ~13-0 Ma Eastern California shear zone (Dokka
                and Travis, 1990ab; Dokka, 1993). From ~13-0 Ma, the region has been subject to rightlateral shearing within the Eastern California shear zone, which accounts for the
                numerous active, right-lateral, dominantly strike-slip faults in the Mojave region
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='pb-5'>
                The Bagdad-Chase Mine is located in the northern part of the Bullion Terrane in the
                central Mojave Desert, southern Basin and Range Province. The mine is about 3 miles S
                of the Kane Springs Fault, a northeast-striking dominantly right-lateral internal transform
                fault zone that separates the Bullion Terrane south of the fault from the Daggett
                (extensional) Terrane north of the fault (Dokka, 1986). At its western limit, the strike of the
                Kane Springs fault curves to a northwesterly trend and becomes the western bounding
                "break-away" (detachment) fault of the Daggett Terrane. Strata in the Bullion Terrane dip
                20-40ENE in contrast to beds in the Daggett Terrane, which dip 55-65SW. Just N of the
                Bagdad Chase Mine area, bedding appears from aerial photographs to dip to the
                southeast. In the area of the Bagdad Chase Mine, all of the surface exposures of the
                hydrothermal breccia have sharp hanging wall and footwall contacts with consistent
                northwest strike and 25-40NE dip. The central Mojave underwent extensional deformation
                preceded by and contemporaneous with basalt to rhyolite volcanism in Miocene time
                (Gans and others, 2005; Dokka, 1986; Walker and others, 1990; Dokka and others, 1998;
                Glazner and others, 2002). During late Cenozoic time, the central Mojave experienced
                three structurally different and temporally separated intervals of deformation (Dokka and
                others, 1998): 1. ~N-S directed opening of the ~24-21 Ma Mojave Extensional Belt (Dokka
                1989; Ross, 1995). The northern Mojave Desert underwent extension beginning ~24 Ma;
                detachment faults accounted for much of the extension and locally exhumed mid-crustal
                rocks (metamorphic core complexes). 2. ~E-W striking, dextral shearing (~21-18 Ma)
                along the Trans Mojave-Sierran shear zone (Dokka and Ross, 1995, 1996, 1998). At ~20
                Ma, the kinematics along the northern boundary changed from extension to dextral shear
                and minor extension in the Trans Mojave-Sierran shear zone, and rocks within this eastwest trending zone (southern Sierra Nevada and the central Mojave Desert) were rotated
                about vertical axes as much as ~40-60 degrees clockwise. 3. ~13-0 Ma Eastern California
                shear zone (Dokka and Travis, 1990ab; Dokka, 1993). From ~13-0 Ma, the region has
                been subject to right-lateral shearing within the Eastern California shear zone, which
                accounts for the numerous active, right-lateral, dominantly strike-slip faults in the Mojave
                region. Although widely accepted that plate motions directly controlled Neogene
                deformation of coastal areas of the southern Cordillera (e.g., Luyendyk, 1991, cited in
                Dokka and Ross, 1995), application to the interior of the North American plate has been
                hampered by lack of clear-cut geometric and kinematic links to the global plate circuit,
                and the poor correlation of plate boundary type with interior deformation (Dokka and
                Ross, 1995). Current understanding suggests that early Miocene extension in eastcentral Nevada occurred in a back-arc setting east of the subducting Farallon Plate north
                of the Mendocino Triple Junction, while extension and concurrent basalt to rhyolite
                volcanism in southeastern California developed opposite and east of the transform that
                was active along the North American plate margin south of the Mendocino Triple Junction.
                The calc-alkaline suite of rocks commonly occurs along destructive plate margins, but is
                also associated with regions undergoing extension. Not all terranes with calc-alkaline
                rocks are associated with subduction zones (Sheth and others, 2002)
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).

            </div>

            <div className='text-xl font-bold text-center pb-5'>MINERALOGY AND STRUCTURAL CONTROLS</div>

            <div className='pb-5'>
                The Bagdad-Chase and Ragtown district is essentially an epithermal, breccia type of
                mineralization. Therefore, the mineralization may be predicted to have a short vertical
                range. However, the hydrothermal alteration associated with mineralization has a
                widespread areal extent. The more favorable areas are breccia zones in the intrusive
                along a fault contact of a stock-like body and altered pyroclastic and flow rocks. The
                greatest production was obtained from the area where the fault contact changes in
                strike from east-west to a more northerly direction. Post-mineral faulting has displaced
                the breccia zones and the western limit of mineralization is limited by a fault striking in a
                northerly direction (Collier and others, 1957. p. 1).
            </div>

            <div className='pb-5'>
                Mineralization is a polymetallic deposit (Deposit occurrence model information: Model
                code: 129; USGS model code: 40a; Deposit model name: Detachment-fault-related
                polymetallic Cu-Au-Ag-Pb-Zn deposits) hosted in quartz-hematite hydrothermal volcanic
                breccia (agglomerate). The ore body is blanket shaped (mantos). Controls for ore
                emplacement included faulting and changes in pressure and temperature of the
                hydrothermal fluid. Local alteration includes propylitic, potassic & argillic. Associated
                rocks include Miocene rhyodacite & porphyry rhyodacite. Local rocks include Tertiary
                intrusive rocks (hypabyssal), unit 7 (Northern Mojave Desert)
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='pb-5'>
                Ore materials include native gold, covellite, chalcopyrite, galena, chalcocite, chrysocolla,
                malachite, azurite and sphalerite. Gangue materials include quartz, specular hematite,
                altered rhyodacite breccia fragments and altered rhyodacite porphyry wall rock
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='pb-5'>
                Mineralization at the Bagdad Chase is believed to be detachment-fault-related and of the
                same or slightly younger age as the deposit's associated presumed early Miocene-age
                rhyodacite porphyry intrusive rocks. Such deposits contain either copper-gold or leadzinc-silver minerals that are typically found along low-angle normal faults (detachment
                faults) or along high-angle faults in the hanging walls of the detachment faults (Spencer
                and Welty, 1989, Long, 1992, cited in Tosdal and others, 1992, p. 38). Massive
                replacement bodies, breccias, and veins of specular hematite are characteristic of these
                deposits. Tosdal and others (1992, p. 38-39) classified base- and precious-metal deposits
                found in the extended terranes in the West Mojave Management Area, as detachmentfault-related polymetallic deposits (model 40a of Long, 1992). They included the BagdadChase Mine as a possible example of this type of deposit. Previously, deposits in the
                Stedman Mining District have been included in the grade and short tonnage models for
                quartz-alunite systems (Mosier and Menzie, 1986, cited in Tosdal and others, 1992, p.
                39). Tosdal and others (1992) cite Polovina (1980) and conclude that the character and
                texture of the Stedman ores are incompatible with the quartz-alunite deposit model. Age
                of Mineralization: Miocene -- contemporaneous with or somewhat younger than the
                enclosing rhyodacite porphyry wallrock; based on correlation of undated, altered
                rhyodacite porphyry wall rock with the Cady Mountain Dacite, which crops out 20 km (12,4
                mi) to the north and has a potassium-argon date of 20.2 ?1.3 m.y. (Glazner, 1981, cited
                in Polovina, 1987, p. 46). . Host Rock: Hydrothermal quartz-hematite breccia consisting
                of poorly sorted, angular to subrounded fragments of argillically altered and leached
                rhyodacite, set in a fine-grained matrix of hydrothermal quartz and specular hematite.
                Host Rock Age: Miocene -- same as or younger than associated rhyodacite hypabyssal
                intrusives that may correlate with the Cady Mountain Dacite, which crops out 20 km (12.4
                mi) to the north and has a potassium-argon date of 20.2 ?1.3 m.y. (Glazner, 1981, cited
                in Polovina, 1987, p. 46). Associated Rock Types: Rhyodacite porphyry intrusives. Host
                Rock Unit: Unnamed hydrothermal breccia. Host Rock Unit Age: Miocene --
                contemporaneous with or slightly younger than rhyodacite porphyry wallrock; based on
                correlation of the rhyodacite porphyry wallrock with the Cady Mountain Dacite, which
                crops out 20 km (12.4 mi) to the north and has a potassium-argon date of 20.2 ?1.3 m.y.
                (Glazner, 1981, cited in Polovina, 1987, p. 46)
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='text-center'>
                <div className='text-xl font-bold '>GOLD-COPPER MINERAL RESOURCES OF THE BAGDAD-CHASE DISTRICT</div>
                <div className='pb-5'>(Collier and others, 1957)</div>
                <div>Occurrence</div>
            </div>

            <div className='pb-5'>
                In the Bagdad-Chase district there are essentially three main types of occurrences in
                which the metallic deposits are found: breccia zones, veins and replacement or deposits
                along bedding(?) zones in the pyroclastics (Collier and others, 1957, p. 2).
            </div>

            <div className='text-xl font-bold'>Breccia Zones</div>

            <div className='pb-5'>
                All the important deposits are of the tectonic breccia type. These breccia zones occur
                within the andesite porphyry stock and especially near the contact with the volcanic
                sequence. The breccia zones at or near the volcanic-intrusive contact seem to be of hi
                her grade (Collier and others, 1957, p. 2).
            </div>

            <div className='pb-5'>
                The tectonic breccia zones vary in width, but locally may be as much as 20 feet wide.
                Depending upon where they are located in the district, they have different attitudes. At
                the Bagdad-Chase mine the breccia zones appear to be striking in a northwesterly
                direction and dipping to the northeast at approximately 30 degrees. This attitude is
                common, although there are many variations. (Collier and others, 1957, p. 2).
            </div>

            <div className='text-center'>Mineralogy.</div>

            <div className='pb-5'>
                The breccias consist of fragments of andesite porphyry cemented by silica containing iron
                oxides. The main value of these breccias was gold, which probably occurred as finely
                divided material in the silica. Secondary copper in the form of malachite occurs commonly
                in these breccia zones as either replacements of the fragments or the silica cement and/or
                as fillings in cavities. The source of the secondary copper was not determined, but there
                may have been primary copper minerals originally present in the breccias. The siliceous
                nature of the ore is of economic importance since smelter premiums will be paid on high
                silica ore. Even though the average copper tenor may be low for under round mining
                methods, the ore may well be economic based upon the high silica and gold content
                (Collier and others, 1957, p. 2-3).

            </div>

            <div className='pb-5'>
                Manganese oxides are present on some fractured surfaces. The amount of these oxides
                is found to increase away from the Bagdad-Chase mine, which indicates a zonal
                arrangement. Barite fills some fractures in the breccias, indicating it was later than the
                main silicification and probably deposited during the cooler phase (Collier and others,
                1957, p. 3).
            </div>

            <div className='text-center'>Barite</div>

            <div className='pb-5'>
                Veins of barite containing galena and/or malachite, and veins of black calcite occur
                essentially in a zonal arrangement in respect to the Bagdad-Chase mine. Locally they
                may form extensive deposits, as indicated by the large barite vein at the Virginia mine
                and the similar occurrence of a black calcite vein in Section 33, Township. 7N., Range.
                8E. Very little production appears to have been obtained from these veins (Collier and
                others, 1957, p. 3).
            </div>

            <div className='text-center'>Barite Vein Mineralogy</div>
            <div className='pb-5'>
                The veins are essentially of two types: barite with galena or secondary copper and black
                calcite. They have generally been prospected, but there is little evidence that any large
                production was derived from them (Collier and others, 1957, p. 3).
            </div>

            <div className='pb-5 text-center'>Replacement Deposits in Altered Pyroclastic Rocks</div>

            <div className='pb-5'>
                In Section 12 there are a number of workings which were developed on a purple colored,
                fine grained zone in the hydrothermally altered pyroclastics. These zones strike in a
                northwesterly direction and dip approximately 40° to the northeast. No metallization was
                observed in these zones (Collier and others, 1957, p. 3).
            </div>

            <div className='pb-5'>
                The pyroclastic and flow deposits have been intensely altered by hydrothermal activity.
                There has been the development of kaolinite, epidote,sericite, pyrite, and possibly some
                silicification. The entire volcanic sequence has taken on a massive appearance and a
                brownish white color (Collier and others, 1957, p. 6).
            </div>

            <div className='text-lg font-bold text-center'>MINE GEOLOGY</div>

            <div className='pb-5'>
                The ore occurs in a fault breccia zone between a quartz monzonite footwall and a rhyolite
                hanging wall. The breccia contains fragments of both of these rocks in a siliceous matrix
                which carries gold and oxidized copper minerals, principally chrysocolla. The mineralized
                breccia zone strikes east, dips gently north, ranges in width from 8 to 20 feet, and is
                several hundred feet long. North-striking faults have displaced the zone as much as 240
                feet (Wright, 1953, p. 71).
            </div>

            <div className='pb-5'>
                The southern Bagdad-Chase mine lies on the Bagdad-Chasse fault lineament. This is a
                zone of anastomosing faults that connect unnamed prospects and the Old Pete Mine on
                the north end with the Ambush Canon Mine on its south end. Where the zone exhibits
                dilation and fault pairing is where ore bodies are developed at fault intersections
                (Wilkerson, this paper).
            </div>

            <div className='pb-5'>
                The district consists of volcanic flows and pyroclastic rocks intruded by intermediate
                basic igneous rocks. There appears to be no doming effect upon the volcanic sequence
                by the intrusions, but faulting occurred throughout and after the mineralization period
                (Collier and others, 1957, p. 7).
            </div>

            <div className='pb-5'>
                The main productive area of the district is near the contact of the altered rocks and the
                intrusive bodies. This contact zone trends approximately N 80° E in the western part of
                the district; in the eastern part it trends in a northerly direction. The Bagdad-Chase
                mine, which produced most of the values of the district, <span className='text-[#ff0000]'>is located essentially at the
                    change in strike of this contact zone</span> (Collier and others, 1957, p. 7).
            </div>

            <div className='pb-5'>
                The beds of the volcanic sequence trend in a northwesterly direction and dip moderately
                to the northeast (Collier and others, 1957, p. 7).
            </div>

            <div className='pb-5'>
                Although very few faults were mapped in the hydrothermally altered volcanic sequence,
                the author believes that intensive faulting had occurred in this area. The alteration
                makes it difficult to determine the locations of the planes along which movements
                occurred (Collier and others, 1957, p. 7).
            </div>

            <div className='pb-5'>
                Post-mineral faulting has occurred since the mineralized breccia zones of the BagdadChase mine have been displaced by northerly trending faults. There is also a major
                post-mineral fault located at the western limit of the mineralization. The type of
                movement along this fault is not known, but there are strong suggestions that it may
                have been right lateral (Collier and others, 1957, p. 7).
            </div>

            <div className='pb-10'>
                At the eastern limit of the district a probable fault, which would be covered mainly by
                Recent alluvium, has been proposed since to the. east Jurassic(?) monzonite porphyry
                crops out. This fault would form a relatively sharp boundary and, therefore, would be a
                controlling feature in searching for mineralization to the east under the alluvium (Collier
                and others, 1957, p. 7-8).
            </div>

            <div className='text-lg font-bold text-center'>ALTERATION</div>
            <div >
                The major types of alteration at the Bagdad-Chase are Copper-Porphyry type propylitic,
                potassic, and argillic alterations (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May
                19, 2020).
            </div>

            <div className='pt-5 text-lg font-bold'>DEVELOPMENT</div>

            <div className='text-lg font-bold text-center pb-5'>WORKINGS</div>

            <div >
                Workings include surface and underground openings. Workings Type: 1. Historic
                underground workings (1901-1954); 2. Open-pit workings: (~1972-1975).
            </div>

            <div className='py-5'>Description of Mine Workings:</div>

            <div>
                1. Historic underground workings (1901-1954): 4+ vertical shafts from 125 to 400 feet
                deep; 450-foot, 40? (30? also reported), N 72? W- trending inclined shaft (decline); over
                5000 feet of drifts and crosscuts at various levels (90-, 140-, 200-, 300-, and 400-foot
                levels); glory hole from the 90-foot level to the surface (working from the 125-foot shaft).
                Mining was by a modified method of coal mining using pillars (room and pillars), also post
                and head board occasionally, with practically no timbering
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='py-5'>
                2. Open-pit workings (~1972-1975): three relatively shallow pits (Bagdad, Middle Mine,
                and Roosevelt pits) and adjacent hillside excavations involving approximately 0.02 square
                mile of disturbed ground (estimated from satellite images and aerial photos from Google
                Earth and NASA World Wind 1.3)
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='text-lg font-bold text-center pb-5'>OPEN PIT AND ORE STOCKPILE</div>

            <div>
                The remnant of the open pit excavated from 1972 to 1975 covers an area of 62 acres.
                North of the pit is a remnant ore stockpile of colorful rocks covering 20 acres. The ore
                stockpile exhibits malachite, azurite, turquoise and chalcanthite with jasper and agate.
            </div>

            <div className='text-lg font-bold text-center py-5'>PRODUCTION AND RESERVES</div>

            <div>
                Production and Reserves: (~9 metric tons Au produced; 5.2 metric tons open-pit
                reserves); plus Ag and Cu (amount undetermined). Reserves: 166,919 troy oz Au (~5.2
                metric tons; 1,102,500 short tons ore grading 0.1514 oz Au/short ton; Northern Miner,
                April 1988). Total Production plus Reserves 1,846,500 to 1,902,500 short tons ~455,800
                troy ounces (~14.2 metric tons) F. W. Royer, Consulting Engineer, Report on shipments
                made from property from 1910 to 1916 (Royer, cited in Tucker, 1934a): Dry short tons
                ore
            </div>

            <div className='py-5'>
                Gold troy oz/short ton<br />
                Total 0.359 tons Av. 1.524 Av. 1.825 Av. 37,220 troy oz Au total 158,019 troy oz<br />
                Silver troy oz/short ton<br />
                Ag total 1892 short tons Au:Ag ratio = 1:4.2 (~1:4)
            </div>

            <div className='pb-5'>
                Tucker (1934a) reported the following "estimated available tonnage": Bagdad-Chase:
                95,000 short tons 0.25 troy oz/st Au 0.90 troy oz/st Ag 1.23 % Cu Middle section: 50,000
                short tons 0.30 troy oz/st Au 1.03 troy oz/st Ag 0.90 % Cu North section: 300,000 short
                tons 0.225 troy oz/st Au 1.00 troy oz/st Ag 1.10 % Cu Misc. sections: 25,000 short tons
                0.45 troy oz/st Au 1.00 troy oz/st Ag 1.20 % Cu 470,000 short tons 0.25 troy oz/st Au 0.98
                troy oz/st Ag 1.11% Cu (Average) (Average) 117,500 tr oz Au total 462,000 tr oz Ag total
                5419 short tons Cu total Gold:silver ratio: ~1:4
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='py-5'>
                Because the ore is siliceous and highly desired by smelters, the producer is given
                preferential treatment charges. Also, the mine was able to operate during World War II
                when the War Production Board's Ligitation order L-208 had shut down most other goldproducing mines. Shipments are made to the Hayden, Arizona or Selby, California
                smeltersof the American Smelting and Refining Company (Wright, 1953, p. 72).
            </div>

            <div>
                Production statistics: Year: 1916 (period = 1910-1916) (ore-accurate): ^1.82% Cu, 0.35
                ounce Au/ton, 1.5 ounce Ag/ton (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May
                19, 2020).
            </div>

            <div className='py-5'>
                Recoveries:
                Ag = 42 grams/metric ton; Au = 10 grams/metric ton; Cu = 2 weight percent
                (<a href='https://www.mindat.org/loc-88031.html' target='_blank' rel='noreferrer noopener'>https://www.mindat.org/loc-88031.html</a> accessed May 19, 2020).
            </div>

            <div className='text-lg font-bold'>REFERENCES</div>

            <div className='py-5'>
                Bagdad Chase Inc. (2006), 10-K 1999 Annual Report:
                <a href='http://www.getfilings.com/o0000009128-00-000001.html' target='_blank' rel='noreferrer noopener'>http://www.getfilings.com/o0000009128-00-000001.html</a>.
            </div>
            <div>
                Belden, L. B. (1952), as reported in an article in the San Bernardino Sun-Telegram:
                Bagdad Chase was discovered in 1899 by John Suter; cited in the California Mining
                Journal, November 1987, p. 4.
            </div>
            <div className='py-5'>
                Bortugno E.J. and T.E. Spittler, 1986, Geologic Map of the San Bernardino Quadrangle,
                1:250,000, Regional Geologic Map Series, Map No. 3A (Geology), Sheet 1 of 5.
                Bulletin of the Mineralogical Society of Southern California (2006): 76 (April).
            </div>
            <div>
                California Geological Survey, Portions of various unpublished reports, and information
                from various Internet websites, contained in California Geological Survey (formerly
                California Division of Mines and Geology) Minefile Folder No. 322-5555.
            </div>
            <div className='py-5'>
                California Mining Journal (1987), Old Bagdad Chase gold mine, gearing up for new
                production: California Mining Journal: 57(3): 3-4.
            </div>
            <div>
                Cloudman, H.C. (1913): Pacific Mines Corporation, formerly Bagdad Chase & Roosevelt
                Consolidation: California State Mining Bureau Field Report 111; California Geological
                Survey (formerly California Division of Mines and Geology) Minefile Folder No. 322-
                5555.
            </div>
            <div className='py-5'>
                Cloudman, H.C., F.J.H. Merrill & E. Huguenin (1919), San Bernardino County: California
                Mining Bureau. Report 15: 774-899; […(abstract): Geol. Zentralbl., 8 and 27: 394].
            </div>



            <div>
                Collier, John T. and J.S Vanderpool, 1957, Aerial Economic Geology of T.6N, R.07 and
                08E, SBM, Southern Pacific Corporation, Unpublished map in support of Minerals for
                Industry, Southern California Volume III, Special Publication 95, California Division of
                Mines and Geology, 1987; additions by R, Antil, A Cunningham an M. Schafer, 1958.
            </div>
            <div className='py-5'>
                Collier, J.T, C.L.D. Cohen and J.S. Vanderpool, 1957, Geology and Mineral Resources
                of Part of Townships 6 and 7 North, Range 8 East Half, San Bernardino Meridian, San
                Bernardino County, California - Includes Bagdad-Chase and Ragtown Gold-Copper
                District, Unpublished report, Southern Pacific Company in support of Minerals or
                Industry, vol. 3, p. 115.
            </div>
            <div>Cooper, J. R., 1962, Bismuth of the United States: USGS MR - 2</div>
            <div className='py-5'>
                Dibblee, T.W., 1967d, Geologic map of the Ludlow quadrangle, San Bernardino County,
                California: U.S. Geological Survey, Miscellaneous Geologic Investigations Map I-477,
                scale 1:62,500.
            </div>
            <div>
                Dibblee, T.W., and Minch, J.A., 2008f, Geologic map of the Ludlow & Bagdad 15 minute
                quadrangles, San Bernardino County, California: Dibblee Geological Foundation,
                Dibblee Foundation Map DF-396, scale 1:62,500.
            </div>
            <div className='py-5'>
                Dokka, R. K. (1986), Patterns and modes of early Miocene crustal extension, central
                Mojave Desert, California, in Mayer, Larry, Editor, Extensional Tectonics of the
                Southwestern United States: A Perspective on Processes and Kinematics: Geological
                Society of America Special Paper 208: 75-95.
            </div>
            <div>
                Dokka, R. K., Ross, T. M., and Lu, G. (1998), The trans Mojave-Sierran shear zone and
                its role in Early Miocene collapse of southwestern North America, in Holdsworth, B.,
                Dewey, J., and Strachan, R., Eds., Continental Transpressional and Transtensional
                Tectonics: Geological Society of London Special Publication 135: 183-202.
            </div>
            <div className='py-5'>
                Eric, J.C. (1948), Tabulation of Copper Deposits in California in: Copper in California:
                California Division of Mines Bull. 144: 199-357.
            </div>
            <div>
                Feller, Walter (2002), Stedman: Mojave Desert Ghost Town Books:
                <a href='http://digital_desert.com/stedman/' target='_blank' rel='noreferrer noopener'>http://digital_desert.com/stedman/</a>.
            </div>
            <div className='py-5'>
                Gans, Philip, DeVecchio, D., Singleshort ton, J., Van Pelt, J., Wong, M., and Reynolds,
                J. (2005), Cenozoic magmatic and structural evolution of the central Mojave Desert,
                California: new constraints from 40Ar/39Ar geochronology and thermochronology:
                Geological Society of America, Cordilleran Section 101st Annual Meeting, April 29-May
                1, 2005, Paper No. 44-10.
            </div>
            <div>
                Gardner, Dion Lowell (1940), Geology of the Newberry and Ord Mountains, San
                Bernardino County, California: California Division Mines Report 36: 257-292.
            </div>

            <div className='py-5'>
                Glazner, A. F., Walker, J. D., Bartley, J. M., and Fletcher, J. M. (2002), Cenozoic
                evolution of the Mojave block of southern California: Geological Society of America
                Memoir 195: 19-41.
            </div>
            <div>
                Goodwin, J. G., 1957 , Lead and Zinc in California, California Journal of Mines and
                Geology, California Division of Mines and Geology, Vol. 53 , No. 3 & 4; P. 613
            </div>
            <div className='py-5'>
                London Mining Journal (1987), Bentley Expands Bagdad Holdings. (April 17, 1987):
                292.
            </div>
            <div>
                London Mining Journal. Bentley Expands Bagdad Holdings. April 17, 1987: 292.
            </div>
            <div className='py-5'>
                Long, K. R. (1992), Descriptive model for detachment-fault-related polymetallic
                deposits, in Bliss, J. D., ed., Developments in mineral deposit models: USGS Bulletin
                2004, p. 52-58.
            </div>
            <div>
                Mansfield, Ross (2005): Off Road touring in the Buckeye mining district; Ludlow,
                Ragtown, Stedman and the Ludlow & Southern Railway: <a href='http://www.offroad.com/dirtbike/features/2005/ludlow_stedman/' target='_blank' rel='noreferrer noopener'>http://www.offroad.com/dirtbike/features/2005/ludlow_stedman/</a>
            </div>
            <div className='py-5'>
                Murdoch, Joseph & Robert W. Webb (1966), Minerals of California, Centennial Volume
                (1866-1966): California Division Mines & Geology Bulletin 189: 144.

            </div>
            <div>
                Northern Miner, April 11, 1988: NM on-line archives.
            </div>
            <div className='py-5'>
                Northern Miner, February 29, 1988: NM on-line archives.
            </div>
            <div>
                Northern Miner, July 25, 1988: NM on-line archives.
            </div>
            <div className='py-5'>
                Northern Miner, June 15, 1987: NM on-line archives.
            </div>

            <div>
                Pemberton, H. Earl (1983), Minerals of California; Van Nostrand Reinholt Press: 514.
            </div>
            <div className='py-5'>
                Phelps, G.A., Bedford, D.R., Lidke, D.J., Miller, D.M., and Schmidt, K.M., 2012,
                Preliminary surficial geologic map of the Newberry Springs 30' x 60' quadrangle,
                California: U.S. Geological Survey, Open-File Report OF-2011-1044, scale 1:100,000.
            </div>
            <div>
                Polovina, J. S. (1980), Mineralized hydrothermal breccias in the Stedman district, San
                Bernardino County, California, in Fife, D. L. and Brown, A. R., Editors, Geology and
                Mineral Wealth of the California Desert: South Coast Geological Society; Santa Ana,
                California, p. 314-317.
            </div>
            <div className='py-5'>
                Polovina, J. S. (1980b), The geology and mineral deposits of the and vicinity, Stedman
                district, San Bernardino County, California [MS Thesis], University of California, Los
                Angeles, 125 pp.
            </div>

            <div>
                Polovina, J. S. (1984), Origin and structural evolution of gold-silver-copper bearing
                hydrothermal breccias in the Stedman mining district, southeastern California, in
                Wilkins, Joe, Jr., Gold and silver deposits of the Basin and Range province, western
                U.S. A.: Arizona Geological Society Digest, Vol. XV, Tucson, Arizona: 159-165.
            </div>
            <div className='py-5'>
                Polovina, J. S. (1987), Origin and structural evolution of gold-silver-copper bearing
                hydrothermal breccias in the Stedman mining district, southeastern California in Bulk
                mineable precious metal deposits of the western United States, Guidebook for field
                trips, April 6-8, 1987: 45-51.
            </div>
            <div>
                Randol Mining Directory (1990).
            </div>
            <div className='py-5'>
                Rogers, Thomas H., 1967, Geologic Map of California, Olaf P. Jenkins Edition, San
                Bernardino Sheet, California Division of Mines and Geology, Scale 1:250,000.
            </div>
            <div>
                Ross, D. G. (2006), The Bagdad Chase Mine: <a href='www.ttrr.org/ls_text/lspb_002.html' target='_blank' rel='noreferrer noopener'>www.ttrr.org/ls_text/lspb_002.html</a>.
            </div>
            <div className='py-5'>
                Royer, F. W. (1934), Mining Engineer, Report on ore shipments from the Bagdad Chase
                property from 1910 to 1916 in Tucker, W. B., 1934: State Mining Bureau Field Report
                111, May 20, 1934; CGS (formerly CDMG) Minefile Folder No. 322-5555.
            </div>
            <div>
                Sheth, H. C., Torres-Alvarado, I.S., and Verma, S.P. (2002), What is the "Calc-alkaline
                rock series"?: International Geology Review: 44(8)(1 August 2002): 686-701.
            </div>
            <div className='py-5'>
                Stewart, R. M. (1951), Preliminary Report No. 30, San Bernardino County, April 1951, 2
                p.; CGS (formerly CDMG) Minefile Folder No. 322-5555.
            </div>
            <div>
                The Gold Ledge, p. 3 of 6:
                <a href='www.goldledge.com/history/docs_html/metals_san_bernardino.html' target='_blank' rel='noreferrer noopener'>www.goldledge.com/history/docs_html/metals_san_bernardino.html</a>


            </div>
            <div className='py-5'>
                Tosdal, R. M., Rytuba, J. J., Theodore, T. G., Ludington, S. L., Jachens, R. C., Miller, R.
                J., Keith, W. J. (1992), Evaluation of selected metallic and nonmetallic mineral
                resources, West Mojave Management Area, southern California: USGS Open-File
                Report 92-595, 89 pp.
            </div>
            <div>
                Tucker, W. B. (1917), Pacific Mines Company, formerly Bagdad, Chase, and Roosevelt
                Mines: California State Mining Bureau Field Report Supplement 111; CGS (formerly
                CDMG) Minefile Folder No. 322-5555.

            </div>
            <div className='py-5'>
                Tucker, W.Burling (1923), Los Angeles Field Division, San Bernardino County
                California, Mining Bureau Report 19: 165-173.
            </div>
            <div>
                Tucker, W. B. (1934a), Bagdad Chase & Roosevelt Mines: California State Mining
                Bureau Field Report #111, revised; CGS (formerly CDMG) Minefile Folder No. 322-
                5555.
            </div>

            <div className='py-5'>
                Tucker, W. B. (1934b), Bagdad-Chase Mine tailings: California State Mining Bureau
                Field Report #37; CGS (formerly CDMG) Minefile Folder No. 322-5555.

            </div>
            <div>
                Tucker, W. Burling (1934c), Current Mining Activity in Southern California; San
                Bernardino County: California Journal of Mines and Geology, California Division of
                Mines (Report 30): 30(4): 323-326.
            </div>
            <div className='py-5'>
                Tucker, W. Burling & Reid J. Sampson (1930), Los Angeles field division: San
                Bernardino County, California Mining Bureau. Report 26: 202-325.
            </div>
            <div>
                Tucker, W. Burling & Reid J. Sampson (1931), Los Angeles Field Division; 27th Report
                of the State Mineralogist; San Bernardino County: California Mining Bureau. Report 27:
                262-401.
            </div>
            <div className='py-5'>
                Tucker, W. Burling & Reid J. Sampson (1940a), Current mining activity in southern
                California: California Division Mines Report 36: 29.
            </div>
            <div>
                Tucker, W. Burling & Reid J. Sampson (1940b), Economic mineral deposits of the
                Newberry and Ord Mountains, San Bernardino County: California Division Mines Report
                36(3): 232-233.
            </div>
            <div className='py-5'>
                Tucker, W.B. and R.J. Sampson, 1943a, Los Angeles Field District, Journal of Mines
                and Geology, State Division of Mines, Vol., 39, No. 1, p. 443.
            </div>
            <div>
                Tucker, W. Burling & Reid J. Sampson (1943b), Mineral resources of San Bernardino
                County: California Division Mines Report 39: 427-550.
            </div>
            <div className='py-5'>
                Tucker, W. Burling (1921), Los Angeles field division: California Mining Bureau. Report
                17: 333-374.
            </div>
            <div>
                U.S. Bureau of Mines, Minerals Availability System (MAS) file #006071
            </div>
            <div className='py-5'>
                USGS (2005), Mineral Resources Data System (MRDS): U.S. Geological Survey,
                Reston, Virginia, loc. file ID #10034008, 10189217 & 10310696.
            </div>
            <div>
                Walker, J. D., Bartley, J. M., Glazner, A. F. (1990), Large-magnitude Miocene extension
                in the central Mojave Desert: implications for Paleozoic to Tertiary paleogeography and
                tectonics: Journal of Geophysical Research: 95(B1): 557-569.

            </div>
            <div className='py-5'>
                Wright, L.A., et al (1953), Mines and mineral resources of San Bernardino County,
                California: California Journal of Mines and Geology: 49(1-2): 71-73.
            </div>


            <div><Maps /></div>


        </div>
    )
}

export default BagdadChaseDeposit